<template>
  <div />
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['spotId']),
  },
  created() {
    if (this.spotId === '0') {
      this.$router.replace('/spots_list');
    } else {
      this.$router.replace('/tickets_list');
    }
  },
};
</script>
